/*
 * Converts a Stripe error code into a human readable string
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just passes through all messages except for the default.
 */
let paymentErrorService = () => {
  const defaultMessage = 'Please check your card details and try again or contact us for help.';

  return {
    formatError: error => error ? error : defaultMessage
  }
};

paymentErrorService.$inject = [];

export default paymentErrorService;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/payment.error.service.js